import { useContext } from 'react';
import type { FC, ReactElement } from 'react';
import { isArray } from 'lodash';

import UserContext from 'app/common/UserContext';
import type { Feature } from 'app/config/features.config';
import { hasAccess, hasAccessToFeature, hasAccessToFeatures } from 'app/utils/permissions';

interface Props {
  children: ReactElement<any> | null;
  access?: UserType[];
  feature?: Feature | Feature[];
  userType?: UserType;
  featureNotAvailable?: Feature;
  condition?: boolean;
}

const PrivateContent: FC<Props> = ({
  children,
  access,
  feature,
  userType: forcedUserType,
  featureNotAvailable,
  condition = true
}) => {
  const { userType: contextUserType } = useContext(UserContext);
  const userType = forcedUserType ?? contextUserType;

  if (
    ((access && hasAccess(access, userType)) ||
      (feature &&
        (isArray(feature)
          ? hasAccessToFeatures(feature, userType)
          : hasAccessToFeature(feature, userType))) ||
      (featureNotAvailable && !hasAccessToFeature(featureNotAvailable, userType))) &&
    condition
  ) {
    return children;
  }

  return null;
};

PrivateContent.displayName = 'PrivateContent';

export default PrivateContent;
